// Mock Data for Design Vision Website

export const services = [
  {
    id: 1,
    title: "Webdesign",
    description: "Moderne, responsive Websites die Ihre Marke perfekt präsentieren und Besucher begeistern.",
    icon: "Globe",
    color: "mid-blue"
  },
  {
    id: 2,
    title: "E-Commerce",
    description: "Professionelle Online-Shops mit nahtloser Benutzererfahrung und sicheren Zahlungslösungen.",
    icon: "ShoppingCart",
    color: "mid-purple"
  },
  {
    id: 3,
    title: "Web-Applikationen",
    description: "Maßgeschneiderte Web-Apps die Ihre Geschäftsprozesse digitalisieren und optimieren.",
    icon: "Layout",
    color: "mid-orange"
  },
  {
    id: 4,
    title: "Mobile Apps",
    description: "Native und plattformübergreifende Apps für iOS und Android, die Ihre Nutzer begeistern.",
    icon: "Smartphone",
    color: "mid-green"
  }
];

export const industries = [
  {
    id: 1,
    title: "Handwerker & Bau",
    description: "Professionelle Websites für Elektriker, Maler, Dachdecker, Installateure und mehr",
    icon: "Wrench",
    image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&q=80",
    bgColor: "#ff965a",
    features: ["Online-Terminbuchung", "Projekt-Galerie", "Kundenbewertungen"]
  },
  {
    id: 2,
    title: "Gastronomie",
    description: "Appetitliche Webauftritte für Restaurants, Cafés und Catering-Services",
    icon: "UtensilsCrossed",
    image: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800&q=80",
    bgColor: "#d987ff",
    features: ["Speisekarten", "Reservierungssystem", "Online-Bestellung"]
  },
  {
    id: 3,
    title: "Fitness & Wellness",
    description: "Dynamische Websites für Fitnessstudios, Personal Trainer und Wellness-Anbieter",
    icon: "Dumbbell",
    image: "https://images.unsplash.com/photo-1540497077202-7c8a3999166f?w=800&q=80",
    bgColor: "#88a2ff",
    features: ["Kursplan-Integration", "Mitglieder-Portal", "Online-Buchung"]
  },
  {
    id: 4,
    title: "Mode & Einzelhandel",
    description: "Stilvolle Online-Shops und Websites für Boutiquen und Einzelhändler",
    icon: "ShoppingBag",
    image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=800&q=80",
    bgColor: "#ffd1e7",
    features: ["E-Commerce", "Produktkataloge", "Größenberater"]
  },
  {
    id: 5,
    title: "Ärzte & Praxen",
    description: "Vertrauenswürdige Webpräsenzen für Arztpraxen, Therapeuten und Gesundheitsdienstleister",
    icon: "Heart",
    image: "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=800&q=80",
    bgColor: "#78d692",
    features: ["Online-Terminbuchung", "Patientenportal", "Leistungsübersicht"]
  },
  {
    id: 6,
    title: "Startups & Tech",
    description: "Innovative Websites und Apps für Tech-Startups und digitale Unternehmen",
    icon: "Rocket",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80",
    bgColor: "#b7fbff",
    features: ["Landing Pages", "SaaS-Plattformen", "MVP-Entwicklung"]
  }
];

// Reference/Demo Projects
export const referenceProjects = [
  {
    id: 1,
    title: "Learn RX",
    description_de: "E-Learning Plattform für medizinische Ausbildung",
    description_en: "E-Learning Platform for Medical Education",
    description_ar: "منصة التعلم الإلكتروني للتعليم الطبي",
    url: "https://learn-rx.com",
    image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=800&q=80",
    features_de: ["Interaktive Kurse", "Zertifizierungen", "Modernes Design"],
    features_en: ["Interactive Courses", "Certifications", "Modern Design"],
    features_ar: ["دورات تفاعلية", "شهادات", "تصميم حديث"]
  }
];

// Keep backward compatibility
export const referenceProject = referenceProjects[0];

export const aboutData = {
  name: "Bastian Rinsche",
  title: "Gründer & Webentwickler",
  bio: "Ich bin Bastian, der Kopf hinter Design Vision. Meine Mission ist es, Unternehmen dabei zu helfen, online sichtbar zu werden – mit Websites und Apps, die nicht nur gut aussehen, sondern auch funktionieren. Ich arbeite eng mit meinen Kunden zusammen, um ihre Ideen in digitale Realität umzusetzen. Dabei setze ich auf moderne Technologien und ein klares, zeitloses Design. Jedes Projekt ist für mich eine neue Möglichkeit, etwas Besonderes zu schaffen.",
  skills: ["Webdesign", "E-Commerce", "Web-Apps", "Mobile Apps"]
};

export const contactInfo = {
  email: "designvision.kontakt@gmail.com",
  phone: "+49 155 67148637",
  whatsapp: "4915567148637",
  address: "Propst-Köster-Straße 34, 59457 Werl, Deutschland"
};

export const legalData = {
  impressum: {
    companyName: "Design Vision",
    owner: "Bastian Rinsche",
    address: "Propst-Köster-Straße 34\n59457 Werl\nDeutschland",
    email: "designvision.kontakt@gmail.com",
    phone: "+49 155 67148637",
    vatId: "DE462605997"
  },
  datenschutz: {
    lastUpdated: "01.01.2025"
  }
};
